import styled from '@emotion/styled'
import { css } from '@emotion/react'
import * as constants from 'view/styles/constants'

export const EnvironmentTitle = styled.div<{ maxWidth?: number }>`
  margin-bottom: 6px;
  max-width: ${props => (props.maxWidth ? `${props.maxWidth}px` : undefined)};
  font-family: NexWeb;
  font-size: 24px;
  color: ${constants.CORE_PRIMARY};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`

export const BannerTileContainer = styled.div<{ removeBorder?: boolean }>`
  display: flex;
  flex-direction: column;
  margin-left: 20px;
  border-right: ${props => (props.removeBorder ? undefined : `2px solid ${constants.CORE_PRIMARY_6}`)};
  &:first-child {
    margin-left: 0;
  }
`

export const TileTitle = styled.div`
  display: flex;
  align-items: center;
  height: 12px;
  margin-bottom: 4px;
  color: ${constants.CORE_PRIMARY};
  text-transform: uppercase;
  font-weight: ${constants.FontWeight.Bold};
  font-size: 10px;
`

export const TileBody = styled.div`
  min-width: 120px;
  display: flex;
  flex: 1;
  flex-direction: column;
  padding-right: 35px;
`

export const heroScrollbarStyles = css`
  ::-webkit-scrollbar {
    height: 4px;
  }

  ::-webkit-scrollbar-track {
    background-color: transparent;
  }

  ::-webkit-scrollbar-thumb {
    background-color: rgba(255, 255, 255, 0.5);
    border: none;
  }
`

export const TilesGroupTitle = styled.div`
  font-family: NEXWeb;
  font-weight: ${constants.FontWeight.Medium};
  font-size: 12px;
  color: ${constants.CORE_PRIMARY_4};
  margin-bottom: 6px;
`

export const TilesContainer = styled.div`
  display: flex;

  & > div {
    display: flex;

    overflow-x: overlay;

    ${heroScrollbarStyles};
  }
`

export const DetailTilesContainer = styled.div<{ large?: boolean; flexDirection?: 'column' | 'row' }>`
  min-width: ${props => (props.large ? '0' : undefined)};
  display: flex;
  flex-direction: ${props => props.flexDirection || 'column'};
  flex: ${props => (props.flexDirection === 'row' ? 1 : 'initial')};

  & ${TilesGroupTitle} {
    font-size: ${props => (props.large ? '14px' : '12px')};
  }
  & ${BannerTileContainer} {
    height: ${props => (props.large ? '89px' : '58px')};
  }

  &:not(:first-of-type) {
    margin-left: 20px;
    div:not(:first-of-type) {
      ${TilesGroupTitle},
      ${TilesContainer} {
        padding-left: 20px;
      }
    }
  }

  &:last-of-type > div:last-of-type ${BannerTileContainer}:last-of-type {
    border-right: none;
  }

  overflow-x: ${props => (props.flexDirection === 'row' ? 'overlay' : undefined)};

  ${heroScrollbarStyles};
`

export const BannerCurrencyTotalTilesContainer = styled.div`
  display: flex;
  flex-direction: 'column';
  overflow: auto;
  overflow-y: hidden;

  & ${TilesGroupTitle} {
    font-size: 13px;
  }

  & ${BannerTileContainer} {
    height: 89px;
  }

  &:not(:first-of-type) {
    margin-left: 10px;
    div:not(:first-of-type) {
      ${TilesGroupTitle},
      ${TilesContainer} {
        padding-left: 10px;
      }
    }
  }

  ${heroScrollbarStyles}
`

export const CurrencyTotalTilesContainer = styled.div`
  display: flex;
  flex-direction: 'column';
`
